import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { Observable, switchMap } from 'rxjs';
import { IItemBase } from '../../../pages/items/items.interface';
import { ELoadStatus } from '../../../state/state.interface';
import { IBaseResponse } from '../../../utilities/http-utilities.service';

export interface IInlineDatePickerComponentState {
  editItemLoading: ELoadStatus;
}
export interface IEditItem {
  dueDate: string;
  id: number;
}

@Injectable()
export class InlineDatePickerStore extends ComponentStore<IInlineDatePickerComponentState> {
  public readonly editItemLoading$: Observable<ELoadStatus> = this.select(
    (state: IInlineDatePickerComponentState) => state.editItemLoading,
  );

  readonly editItemDueDate = this.effect((trigger$: Observable<IEditItem>) =>
    trigger$.pipe(
      switchMap((editItem: IEditItem) => {
        this.patchState({ editItemLoading: ELoadStatus.loading });
        const params = new HttpParams().set('preventIsQuickColumnUpdate', true);

        return this.editItem(editItem, params).pipe(
          tapResponse(
            () =>
              this.patchState({
                editItemLoading: ELoadStatus.success,
              }),
            // eslint-disable-next-line no-console
            (error) => console.error('Error loading data', error),
          ),
        );
      }),
    ),
  );

  constructor(private readonly http: HttpClient) {
    super({
      editItemLoading: ELoadStatus.initial,
    });
  }

  private editItem(item: IEditItem, params: HttpParams): Observable<IBaseResponse<IItemBase>> {
    return this.http.patch<IBaseResponse<IItemBase>>(
      `items/${item.id}`,
      {
        dueDate: item.dueDate,
      },
      { params },
    );
  }
}
